import { TextSpan } from '../../Atoms/Text';
import { Icon } from '../../Atoms/Icon';
import { ProgressBar } from '../../Atoms/ProgressBar';

export interface UploadingAttachmentRowProps {
  fileName: string;
  progress: number;
  onCancel: () => void;
}

export function UploadingAttachmentRow({ fileName, progress, onCancel }: UploadingAttachmentRowProps) {
  return (
    <div
      className="flex items-center gap-3 py-[9px]"
      data-testid="uploading-attachment-row">
      <TextSpan
        className="shrink-0"
        color="grey8"
        size="xs">
        {fileName}
      </TextSpan>
      <div className="grow" />
      <ProgressBar
        className="!h-1 w-[120px] rounded-full shrink-0"
        progress={progress}
        progressBarStyleOverride="h-full bg-indigo rounded-full transition"
      />
      <TextSpan
        className="shrink-0"
        color="grey4"
        size="xs">
        {progress}%
      </TextSpan>
      <button
        type="button"
        onClick={onCancel}
        aria-label={`Cancel upload of ${fileName}`}
        data-testid="uploading-attachment-cancel-button">
        <Icon
          type="cancel"
          className="w-3 h-3"
        />
      </button>
    </div>
  );
}
